<template>
  <div class="message-box">
    <b-modal
        ref="modal-window"
        :size="size"
        modal-class="message-box-modal"
        @hidden="modalClosed"
    >
      <template #modal-header>
        <h5 class="text-center pb-2">{{ title }}</h5>
      </template>

      <template #modal-body>
        <div class="text-center">
          <slot name="message" v-bind="{data, message, title}">
            {{ message }}
          </slot>
        </div>
      </template>

      <template #modal-footer>
        <span v-if="displayBtn('cancel')" class="btn btn-secondary" @click="close()">
          {{ textBtnCancel }}
        </span>
            <span v-if="displayBtn('confirm')" class="btn btn-primary" @click="confirm()">
          {{ textBtnOk }}
        </span>
      </template>
    </b-modal>
  </div>
</template>

<script src="./MessageBox.js" />
